import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import history from "./shared/history";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap";
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/alert";
import store from "./redux/store";
import { Provider } from "react-redux";

ReactDOM.render(
  
    <BrowserRouter history={history}>
      {/* <HashRouter > */}
      {/* <MainProvider> */}

      <Provider store={store}>
        <App />
      </Provider>

      {/* </MainProvider> */}
      {/* </HashRouter> */}
    </BrowserRouter>
  ,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
